module.exports = __webpack_public_path__ + "static/fonts/iconfont.fe79bd65.ttf";